import { Injectable, Optional } from '@angular/core';
// import { Firebase } from '@awesome-cordova-plugins/firebase/ngx';
// import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { Platform } from '@ionic/angular';
import { IFirebaseService } from '@boxx/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding/lib/services/dynamic-branding-service';
//import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { APP_CONSTANTS } from 'src/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAnalyticsService implements IFirebaseService {
  isNative = false;
  isIos = false;

  constructor(
    // @Optional() private firebase: Firebase,
    // @Optional() private firebaseX: FirebaseX,
    private dBrandingService: DynamicBrandingService,
    private platform: Platform
  ) {
    this.platform.ready().then(() => {
      this.isNative = this.platform
        .platforms()
        .some((name) => ['cordova', 'capacitor'].includes(name));
      this.isIos = this.platform
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));

      /* console.log('---- firebase', firebase);
      console.log('---- firebaseX', firebaseX); */
    });
  }

  fetch(cacheExpirationSeconds?: number): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.fetch(cacheExpirationSeconds);
  }

  activateFetched(): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.activateFetched();
  }

  getValue(value: string): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.getValue(value);
  }

  getFullValue(){
  //   this.firebaseX.fetch(60).then(() => {
  //     this.firebaseX.activateFetched().then((value) => {

  //       this.firebaseX.getValue('virket-gmb-agency').then((proj) => {
  //         console.log('proj' + proj)
  //       })
  //       .catch((err) => {
  //         console.log('getvalue err' + err)
  //       })
  //     })
  //     .catch((error2) => {
  //       console.log('activation error' + JSON.stringify(error2));
  //     });
  //   }
  // );
  }

  setAnalyticsCollectionEnabled(val: boolean): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.setAnalyticsCollectionEnabled(val);
  }

  logEvent(name: string, params: unknown): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.logEvent(name, params);
  }

  logFullEvent(name: string, params: any): Promise<unknown> {
    let bName = this.dBrandingService.getCurrentBrandName().toUpperCase();
    let bId = this.dBrandingService.getBusinessId();
    params.business_id = bId;
    params.tradename = bName;
    if(this.isNative){
      return null;
      //return this.firebaseX.logEvent(name + '_' + bName, params);
    }
    else{
      // FirebaseAnalytics.logEvent({
      //   name: name + '_' + bName,
      //   params: {
      //     business_id: bId,
      //     tradename: bName
      //   },
      // });
      // return null;
    }
    //return this.isNative && this.firebaseX.logEvent(name, params);
  }

  setScreenName(name: string): Promise<unknown> {
    let bName = this.dBrandingService.getCurrentBrandName().toUpperCase();
    return null;
    //return this.isNative && this.firebaseX.setScreenName(name + '_' + bName);
  }

  setUserId(id: string): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.setUserId(id);
  }

  setUserProperty(name: string, value: string): Promise<unknown> {
    return null;
    //return this.isNative && this.firebaseX.setUserProperty(name, value);
  }
}
